export const equipmentData = [
  {
    id: 1,
    name: "Ressonância Magnética",
    category: "Diagnóstico por Imagem Avançado",
    description: "Equipamentos de RM de alto campo para imagens anatômicas detalhadas sem radiação.",
    image: "https://images.pexels.com/photos/7089017/pexels-photo-7089017.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "Imagens de alta resolução",
      "Sem radiação ionizante",
      "Múltiplas sequências especializadas",
      "Conforto do paciente"
    ]
  },
  {
    id: 2,
    name: "Tomógrafo",
    category: "Diagnóstico por Imagem",
    description: "Scanners de TC de última geração fornecendo imagens transversais detalhadas para diagnóstico preciso.",
    image: "https://images.pexels.com/photos/13176357/pexels-photo-13176357.jpeg?w=800&q=80",
    features: [
      "Tecnologia multi-slice",
      "Velocidade de varredura rápida",
      "Reconstrução avançada de imagem",
      "Otimização de dose"
    ]
  },
  {
    id: 3,
    name: "Ultrassom",
    category: "Diagnóstico por Imagem",
    description: "Série Aplio A da Canon - focada em departamentos de imagem de rotina com alta produtividade e aplicações avançadas como iSMI e Precision+.",
    image: "https://static.prod-images.emergentagent.com/jobs/7899ab28-0d6a-4e3b-b0e7-b178b443ae26/images/70017e5f86d73364cd042f82e87e693bcf5e0f63c4438b9a227fd44c572a77ac.png",
    features: [
      "iSMI - Visualização microvascular",
      "Precision+ - Contornos nítidos",
      "Alta produtividade para rotinas intensas",
      "Opção a550 WHC (Saúde da Mulher)"
    ]
  },
  {
    id: 4,
    name: "Densitometria Óssea",
    category: "Saúde Óssea",
    description: "Sistemas precisos de medição de densidade óssea para diagnóstico e monitoramento de osteoporose.",
    image: "https://customer-assets.emergentagent.com/job_7899ab28-0d6a-4e3b-b0e7-b178b443ae26/artifacts/ki2lh4ce_WhatsApp%20Image%202026-03-31%20at%2010.02.20%20AM.jpeg",
    features: [
      "Tecnologia DEXA",
      "Tempos de varredura rápidos",
      "Relatórios abrangentes",
      "Medições de alta precisão"
    ]
  },
  {
    id: 5,
    name: "Mamógrafo",
    category: "Diagnóstico por Imagem",
    description: "Sistemas avançados de mamografia digital para rastreamento e diagnóstico de câncer de mama com qualidade de imagem superior.",
    image: "https://static.prod-images.emergentagent.com/jobs/7899ab28-0d6a-4e3b-b0e7-b178b443ae26/images/9d80e9162015b1fa445d0338921ed1f4ae69ef67c20426ecf7602c9e1ba31525.png",
    features: [
      "Imagem digital de alta resolução",
      "Baixa dose de radiação",
      "Capacidade de tomossíntese 3D",
      "Tempos de exame rápidos"
    ]
  },
  {
    id: 6,
    name: "Raio-X",
    category: "Radiologia Convencional",
    description: "Sistema RADREX - solução digital versátil e econômica, com estativa Chão-Teto ou Teto, focada em produtividade e conforto.",
    image: "https://static.prod-images.emergentagent.com/jobs/7899ab28-0d6a-4e3b-b0e7-b178b443ae26/images/6dafaf062170f16192879e95fb120e15ee6e9ed52eab5100c20173960d4e5171.png",
    features: [
      "Mesa Bucky com tampo flutuante 82x210 cm",
      "Memória de posicionamento com um clique",
      "Ampla cobertura longitudinal e vertical",
      "Ideal para pacientes com mobilidade reduzida"
    ]
  },
  {
    id: 7,
    name: "CR (Computed Radiography)",
    category: "Radiologia Digital",
    description: "Sistema de radiografia computadorizada para digitalização de imagens com qualidade diagnóstica superior.",
    image: "https://us.medical.canon/resources/img/products/x-ray/cxdi-wireless/CXDI-Wireless-Digital-Detectors-3-up.jpg",
    features: [
      "Digitalização de placas de fósforo",
      "Alta resolução de imagem",
      "Sistema econômico",
      "Fácil integração com PACS"
    ]
  },
  {
    id: 8,
    name: "DR (Digital Radiography)",
    category: "Radiologia Digital",
    description: "Detectores Digitais Série CXDI (702C e 402C) - sem fio, extremamente leves e duráveis para radiografia de alta definição com baixa dose de radiação.",
    image: "https://static.prod-images.emergentagent.com/jobs/7899ab28-0d6a-4e3b-b0e7-b178b443ae26/images/12f292258324e490605a53077d657e8e50b303778a1558f5e6d15289be17beb2.png",
    features: [
      "Mais de 9,5 milhões de pixels (125 µm)",
      "Aquisição de 16 bits (65 mil tons de cinza)",
      "Pré-visualização em ~1 segundo",
      "IP55 - Resistente a poeira e água"
    ]
  },
  {
    id: 9,
    name: "Workstation (Estação de Trabalho)",
    category: "Infraestrutura de TI Médica",
    description: "Estações de trabalho especializadas para visualização e processamento de imagens médicas.",
    image: "https://static.prod-images.emergentagent.com/jobs/7899ab28-0d6a-4e3b-b0e7-b178b443ae26/images/e141547976f1f1f06d66be8f522524ce145997e05d753a6fa8d345f5f6924b0c.png",
    features: [
      "Alto desempenho de processamento",
      "Monitores de alta resolução",
      "Software especializado",
      "Integração com sistemas PACS"
    ]
  },
  {
    id: 10,
    name: "PACS",
    category: "Infraestrutura de TI Médica",
    description: "Sistema de arquivamento e comunicação de imagens para gerenciamento completo de imagens médicas.",
    image: "https://static.prod-images.emergentagent.com/jobs/7899ab28-0d6a-4e3b-b0e7-b178b443ae26/images/a7d4661504ac960bff086828086b567122e6d94d699c5cae503de9a33e18f16d.png",
    features: [
      "Armazenamento centralizado",
      "Acesso remoto às imagens",
      "Integração com RIS/HIS",
      "Backup e segurança de dados"
    ]
  }
];

export const servicesData = {
  sales: {
    title: "Vendas de Equipamentos",
    description: "Fornecemos equipamentos de diagnóstico por imagem, garantindo que sua instalação tenha acesso à mais recente tecnologia médica.",
    benefits: [
      "Experiência e credibilidade",
      "Preços competitivos",
      "Presença ativa de ponta a ponta no processo comercial",
      "Treinamento de equipe incluído",
      "Pacotes adicionais de manutenção"
    ]
  },
  maintenance: {
    title: "Serviços de Manutenção",
    description: "Nossos programas abrangentes de manutenção mantêm seus equipamentos funcionando com desempenho máximo, minimizando o tempo de inatividade e estendendo a vida útil.",
    benefits: [
      "Programas de manutenção preventiva",
      "Serviços de manutenção corretiva",
      "Técnicos certificados",
      "Peças de reposição genuínas",
      "Otimização de desempenho",
      "Testes de qualidade em transdutores"
    ]
  }
};

export const testimonialsData = [
  {
    id: 1,
    name: "Dra. Maria Silva",
    role: "Radiologista Chefe",
    hospital: "Hospital São Paulo",
    image: "https://images.unsplash.com/photo-1516841273335-e39b37888115?w=400&q=80",
    text: "A Visiomed tem sido nossa parceira de confiança há mais de 10 anos. A qualidade dos equipamentos e o serviço de manutenção são excepcionais.",
    rating: 5
  },
  {
    id: 2,
    name: "Dr. João Santos",
    role: "Diretor Médico",
    hospital: "Clínica Diagnóstico Rio",
    image: "https://images.unsplash.com/photo-1758691463193-9d2b21fdb3ba?w=400&q=80",
    text: "O tomógrafo que adquirimos superou nossas expectativas. A equipe de suporte técnico é sempre prestativa e profissional.",
    rating: 5
  },
  {
    id: 3,
    name: "Ana Costa",
    role: "Administradora Hospitalar",
    hospital: "Hospital Geral Brasília",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=400&q=80",
    text: "O serviço de manutenção reduziu significativamente o tempo de inatividade dos nossos equipamentos. Altamente recomendado!",
    rating: 5
  }
];

export const certificationsData = [
  "Certificado ISO 9001:2015",
  "Aprovado pela ANVISA",
  "Centro de Serviço Autorizado",
  "Técnicos Certificados",
  "Sistema de Gestão de Qualidade"
];

export const serviceAreasData = [
  "São Paulo",
  "Rio de Janeiro",
  "Brasília",
  "Belo Horizonte",
  "Curitiba",
  "Porto Alegre",
  "Salvador",
  "Recife"
];

export const aboutImages = {
  team: "https://images.unsplash.com/photo-1516841273335-e39b37888115?w=1200&q=80",
  technology: "https://images.unsplash.com/photo-1631556760585-2e846196d5a9?w=1200&q=80",
  clinicalWork: "https://images.unsplash.com/photo-1759813641406-980519f58b1c?w=1200&q=80"
};